export class RequestBazowy {
    token: string;
    jezyk: string;
    adresStrony: string;
    idUzytkownika: string;
}